<template>

  <div>
    <Modal
      :title="$t('titles.delete_blackout')"
      :submit="submit"
      :submitting="submitting"
      submit-label="Delete"
    >

      <p>{{ $t('alerts.confirm_delete_blackout', {blackout_name: blackout.name}) }}</p>

    </Modal>
  </div>    

</template>

<script setup lang="ts">

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Modal from '../../Modal.vue'
// @ts-ignore: don't complain about missing types
import { closeDialog } from 'vue3-promise-dialog'
import NotificationService from '../../../services/NotificationService'
import Blackout from '../../../models/Blackout'

interface Props {
  blackout: Blackout
}

const props = defineProps<Props>()

const { t } = useI18n()
const submitting = ref<boolean>(false)

async function submit() {

  submitting.value = true

  Blackout.destroy(props.blackout.ID)
    .then(() => {
      NotificationService.success(t('alerts.blackout_deleted'))
      closeDialog(null)
    })
    .catch((error) => {
      console.error(error)
      const msg = t('alerts.couldnt_delete_blackout')
      NotificationService.error(msg)
    })
    .finally(() => {
      submitting.value = false
    })

}

</script>
